import { Component } from "react";
import { WarningCircle, ArrowClockwise } from "@phosphor-icons/react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || "Unexpected error" };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("App render crash:", error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-[#F9FAFB] px-6 text-center" data-testid="app-error-boundary">
        <WarningCircle size={44} className="text-[#D97706]" weight="fill" />
        <div>
          <h1 className="font-heading text-2xl font-black tracking-tight text-[#0A0A0A]">Something went wrong</h1>
          <p className="mt-1 max-w-md text-sm text-neutral-500">This page hit an unexpected error. Reloading usually fixes it.</p>
          {this.state.message && (
            <p className="mt-2 max-w-md break-words text-xs text-neutral-400">{this.state.message}</p>
          )}
        </div>
        <button
          onClick={() => window.location.reload()}
          data-testid="app-error-reload"
          className="flex items-center gap-2 rounded-sm bg-[#0A0A0A] px-4 py-2 text-sm font-semibold text-white transition-colors duration-200 hover:bg-[#0055FF]"
        >
          <ArrowClockwise size={16} weight="bold" /> Reload page
        </button>
      </div>
    );
  }
}
